import React from 'react'
import {withStyles, ListItem, Grid, Menu, MenuItem,
        IconButton, Tooltip} from '@material-ui/core'
import { PictureInPicture, LibraryBooks, MoreVert, DeleteOutline, FileCopyOutlined} from '@material-ui/icons';
import EE from '../../../../../api/eventemitter'
import LazyLoad from 'react-lazyload';
import Linkify from 'linkifyjs/react';
import config from '../../../../../config/backend'

EE.setMaxListeners(1000) // temporary method to set max EE listeners , as there's yet a way to prevent each library object to have listeners on their own

const styles = {
    addCard:{
        cursor:"pointer"
    },

    category:{
        position:"relative",
        margin:"0",
        fontSize:"14px",
        fontWeight:"bold",
        color:"#fff",
        borderRadius:"5px",
        width:"fit-content",
        padding:"5px 10px",
        background:"#686868",
        zIndex:"2"
    },

    categoryCount:{
        float:"right",
        borderRadius:"5px",
        fontSize:"14px",
        padding:"0 10px",
        background:"#C4C4C4",
        color:"#4f4f4f",
        margin:"0"
    },

    expandBtn:{
        position:"relative",
        border:"1px solid #828282",
        background:"#E1E1E1",
        width:"10px",
        marginRight:"5px",
        height:"10px",
        color:"#828282",
        '&:focus':{
            outline:"none"
        },
        '&:hover':{
            background:"#E1E1E1",
        },
        zIndex:"2"

    }
}

class GameLibraryInfo extends React.Component {
    constructor(props) {
        super(props)
        this.state={
            anchorEl: null,
            //Will contain labels as a state
        }

        this.shiftRegister = null;
        // Tracks whether the current pointer interaction became a drag, so mouseup can tell a
        // plain click (collapse selection) from a drag-out (keep selection).
        this.dragged = false;
    }

    // Scenario 1/2/3 selection model. Selection is committed on PRESS (mousedown) so a card can
    // be highlighted and dragged out in one motion; a plain click on one of many selected cards
    // collapses the selection on RELEASE (mouseup). Shift/Ctrl keep additive selection (Option B).
    handleCardMouseDown = (e, object, index, objects) => {
        if(e.button !== 0){ return } // left button only
        this.dragged = false         // reset for this interaction

        const {selectCardsInLibrary, startSelectCardsLibrary, selectedIDs} = this.props
        const sr = this.shiftRegister

        // Ctrl: toggle this card in/out of the selection (build a multiselect)
        if(e.ctrlKey){
            this.shiftRegister = null
            selectCardsInLibrary(object)
            return
        }

        // Shift: range-select within the same category group (anchor = shiftRegister)
        if(e.shiftKey){
            if(sr == null){
                startSelectCardsLibrary(object)
                this.shiftRegister = {object, index}
            }
            else if(sr.object.category === object.category){
                if(index > sr.index){
                    for(let i = index; i > sr.index; i--){ selectCardsInLibrary(objects[i]) }
                }else{
                    for(let i = sr.index - 1; i >= index; i--){ selectCardsInLibrary(objects[i]) }
                }
            }
            else{
                this.shiftRegister = {object, index}
            }
            return
        }

        // Plain press
        if(!selectedIDs.includes(object.libID)){
            // Scenario 1: unselected card -> highlight now, clearing every other selection, so
            // the user can immediately drag it out (the drop reads selectedIDs).
            startSelectCardsLibrary(object)
            this.shiftRegister = {object, index}
        }
        // Scenario 2 (this is the only selected card) and Scenario 3 press (one of many selected):
        // do nothing on press so a drag keeps the current selection. Scenario 3 collapses on release.
    }

    handleCardMouseUp = (e, object, index) => {
        if(e.button !== 0){ return }
        if(this.dragged){ return }                 // a drag happened -> keep the selection intact
        if(e.shiftKey || e.ctrlKey){ return }      // modifier selection is handled on mousedown

        const {startSelectCardsLibrary, selectedIDs} = this.props

        // Scenario 3: plain click (no drag) on one of many selected cards -> collapse to just this one.
        if(selectedIDs.includes(object.libID) && selectedIDs.length > 1){
            startSelectCardsLibrary(object)
            this.shiftRegister = {object, index}
        }
    }

    handleCardDragStart = () => {
        this.dragged = true
    }

    render(){
        const {objects} = this.props

        return(
            <div style={{position:"relative", marginLeft:"30px", borderLeft:"2px solid #c4c4c4"}}>
                {this.displayContent(objects)}
            </div>
        )
    }

    displayContent = (objects) =>{
        console.log(objects)
        const {
            classes,
            deleteLibrary,
            selectedIDs,
            canDragLibCard,
            duplicateSingleLibraryCard,
        } = this.props
        let contentArr = []

        // console.log("This is library objects content: ",objects)

        for(let index=0; index<objects.length; index++){
            let object = objects[index]
            //C for canvas L for Library. Green = on the canvas, Red = still in the library.
            let objectPlacement = object?.objId || object?.draw ?
                                    <Tooltip title={"Canvas"}>
                                        <PictureInPicture style={{fontSize:"12px", color:"#27AE60"}} />
                                    </Tooltip> :
                                    <Tooltip title={"Library"}>
                                        <LibraryBooks style={{fontSize:"12px", color:"#E45858"}} />
                                    </Tooltip>

            contentArr.push(
                <LazyLoad
                    key={`${index + object}`}
                    height={"10px"}
                    unmountIfInvisible={true}
                >
                    <div
                        key={`${index + object}`}
                        style={{position:"relative"}}
                    >
                        <div style={{position:"absolute",marginTop:"20px", width:"10px", height:"5px", background:"transparent", borderBottom:"2px solid #c4c4c4"}}/>
                        <ListItem
                            onMouseDown={(e) => this.handleCardMouseDown(e, object, index, objects)}
                            onMouseUp={(e) => this.handleCardMouseUp(e, object, index)}
                            onDragStart={this.handleCardDragStart}
                            style={{
                                position: "relative",
                                background: "white",
                                color: "#4f4f4f",
                                borderRadius: "5px",
                                padding: "10px",
                                marginTop: "20px",
                                marginLeft: "10px",
                                width: "calc(100% - 10px)",
                                border: selectedIDs.includes(object.libID)? "thick solid orange" : "transparent",
                                overflowWrap: "break-word",
                                wordWrap: "break-word",
                            }}
                            key={`${object} ${index}`}
                            draggable={canDragLibCard}
                        >

                            <Grid container style={{display:"block"}}>
                                <Grid container>
                                    <Grid item xs={9}>
                                        {
                                            object.imgUrl ?
                                            <div
                                                style={{
                                                    position:"relative",
                                                    width:"100%",
                                                    height:"62px",
                                                    overflow:"hidden",
                                                }}>
                                                <img
                                                    style={{width:"100%"}}
                                                    alt="img"
                                                    src={`${config.backend.uri}/static/uploads/${object.imgUrl}`}
                                                />
                                            </div>
                                            :
                                            object?.content?.length > 0 ?
                                                <Linkify
                                                    options={{
                                                        target: {
                                                            url: '_blank'
                                                        },
                                                    }}
                                                >
                                                    {new DOMParser().parseFromString(object.content, "text/html").body.textContent}
                                                </Linkify> :
                                                <i></i>
                                        }
                                    </Grid>
                                    <Grid item xs={3}>
                                        <IconButton style={{width:"12px", height:"12px", margin:"auto", outline:"none"}} onClick={(e)=>this.openMenu(object.libID, e)}>
                                            <MoreVert style={{color:"#c4c4c4", fontSize:"12px"}}/>
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} style={{color:"#c4c4c4"}}>
                                    <Grid container justify="flex-start" alignItems="center">
                                        <Grid item>
                                            {objectPlacement}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ListItem>
                        <Menu
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.selectedLibID === object.libID}
                            onClose={this.closeMenu}
                        >
                            <MenuItem
                                onClick={() => duplicateSingleLibraryCard(object.libID)}
                                style={{
                                    color: "#4F4F4F",
                                    fontSize: 12,
                                }}
                            >
                                <FileCopyOutlined
                                    style={{
                                        color: "#4F4F4F",
                                        fontSize: 14,
                                        marginRight: 5,
                                    }}
                                />
                                Duplicate
                            </MenuItem>
                            <MenuItem onClick={()=>deleteLibrary(object.libID)}  style={{color:"#4F4F4F", fontSize:"12px"}} disabled={object?.objId ? true : false}>
                                <DeleteOutline style={{color:"#4F4F4F", fontSize:"14px", marginRight:"5px"}}/>
                                Delete
                            </MenuItem>
                        </Menu>
                    </div>
                </LazyLoad>
            )

        }

        contentArr.push(
            <ListItem
                key={Math.floor(Math.random() * Date.now())}
                style={{padding:"0", marginTop:"0", marginLeft:"-7px"}}
            >
                <IconButton disabled className={classes.expandBtn} style={{padding:"5px", background:"#c4c4c4"}}>
                </IconButton>
            </ListItem>
        )

        return contentArr
    }

    openMenu = (libId, event) =>{
        event.stopPropagation()

        this.setState({
            selectedLibID: libId,
            anchorEl: event.currentTarget
        })
    }

    closeMenu = () => {
        this.setState({
            selectedLibID: null,
            anchorEl: null
        })
    }
}

export default withStyles(styles)(GameLibraryInfo)
